import React from 'react'
import { Badge } from '@/components/ui/badge'
import { Info } from 'lucide-react'
import { DesaDetailCard } from '@/components/DesaDetailCard'
import { OrganizationalChart } from '@/components/OrganizationalChart'
import { useDesaDetail, useStrukturPemerintahan } from '@/hooks/use-desa-public'

export default function DesaTentangPage() {
  const { data: strukturPemerintahan } = useStrukturPemerintahan()

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-blue-50 to-purple-50">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-green-600 via-green-700 to-blue-600 overflow-hidden">
        <div className="absolute inset-0 bg-black/20"></div>
        
        <div className="relative container mx-auto px-6 py-20">
          <div className="max-w-4xl">
            <div className="flex items-center gap-3 mb-6">
              <div className="p-3 bg-white/20 rounded-xl backdrop-blur-sm">
                <Info className="w-6 h-6 text-white" />
              </div>
              <Badge variant="secondary" className="bg-white/20 text-white border-white/30 hover:bg-white/30">
                Tentang Desa
              </Badge>
              <span className="text-white/80">•</span>
              <span className="text-white/90">Profil & Informasi</span>
            </div>

            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 leading-tight">
              Tentang Desa
            </h1>

            <p className="text-xl text-white/90 mb-8 leading-relaxed max-w-3xl">
              Informasi lengkap mengenai profil desa, sejarah, dan struktur organisasi pemerintahan desa
            </p>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="container mx-auto px-6 py-12 space-y-12">
        {/* Village Info Section */}
        <section>
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold bg-gradient-to-r from-gray-900 via-green-800 to-gray-900 bg-clip-text text-transparent mb-4">
              Profil Desa
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Informasi lengkap tentang profil desa, kontak, dan wilayah administratif berdasarkan data tahun 2025
            </p>
          </div>

          <DesaDetailCard strukturPemerintahan={strukturPemerintahan} />
        </section>
        
        {/* Organizational Chart Section */}
        {strukturPemerintahan && (
          <section>
            <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
              <div className="p-8">
                <div className="mb-8">
                  <h2 className="text-3xl font-bold bg-gradient-to-r from-gray-900 via-blue-800 to-gray-900 bg-clip-text text-transparent mb-4">
                    Struktur Organisasi
                  </h2>
                  <div className="w-20 h-1 bg-gradient-to-r from-blue-500 to-green-500 rounded-full"></div>
                </div>
                <OrganizationalChart />
              </div>
            </div>
          </section>
        )}
        
        {/* Information Card */}
        <section>
          <div className="bg-gradient-to-r from-green-50 via-blue-50 to-indigo-50 border border-green-200 shadow-lg rounded-2xl">
            <div className="p-8">
              <div className="text-center">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  Profil Desa
                </h3>
                <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
                  Data profil desa dan struktur pemerintahan diperbarui secara berkala untuk memastikan akurasi informasi dan transparansi pemerintahan desa
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}